export default __webpack_public_path__ + "static/media/Photo 11 - MR - vents violents.8c3a96eb.png";